var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_927_910",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_927_910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7122 36.667C17.8419 36.667 17.106 36.3407 16.5047 35.688C15.9033 35.0347 15.6027 34.236 15.6027 33.292H21.8218C21.8218 34.236 21.5211 35.0347 20.9198 35.688C20.3185 36.3407 19.5826 36.667 18.7122 36.667ZM12.5318 31.042V28.25H24.8927V31.042H12.5318ZM12.7621 26C11.0472 24.8333 9.69065 23.3333 8.69251 21.5C7.69438 19.6667 7.19531 17.625 7.19531 15.375C7.19531 11.9583 8.32796 9.02067 10.5933 6.562C12.858 4.104 15.5643 2.875 18.7122 2.875C21.8602 2.875 24.5665 4.104 26.8312 6.562C29.0965 9.02067 30.2292 11.9583 30.2292 15.375C30.2292 17.625 29.7301 19.6667 28.732 21.5C27.7338 23.3333 26.3773 24.8333 24.6623 26H12.7621ZM13.6448 23.208H23.8184C25.0211 22.3193 25.9615 21.1873 26.6396 19.812C27.3177 18.4373 27.6567 16.9583 27.6567 15.375C27.6567 12.6803 26.7867 10.3817 25.0465 8.479C23.3064 6.57633 21.195 5.625 18.7122 5.625C16.2295 5.625 14.1181 6.57633 12.3779 8.479C10.6378 10.3817 9.76773 12.6803 9.76773 15.375C9.76773 16.9583 10.1068 18.4373 10.7849 19.812C11.463 21.1873 12.4163 22.3193 13.6448 23.208Z",
    fill: "#2B74E2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.a709d4751a65288e8e7dc6ea79cfc8cb.svg";
export { ForwardRef as ReactComponent };